module.exports = __webpack_public_path__ + "static/media/c13.6480fa86.png";